import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ModalContent } from '@ap/modal';

import content from '../../mijn-template.content.json';
import { MijnTemplateService } from '../../mijn-template.service';

/**
 * @module SendableOrdersModalModule
 * @ngdoc component
 * @name SendableOrdersModalComponent
 */
@Component({
    selector: 'sendable-orders-modal',
    templateUrl: 'sendable-orders-modal.component.html',
    standalone: false
})
export class SendableOrdersModalComponent extends ModalContent<any> implements OnInit {
    public reload: boolean;

    public constructor(
        private readonly changeDetector: ChangeDetectorRef,
        private readonly contentService: ApContentService,
        private readonly mijnTemplateService: MijnTemplateService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.mijnTemplateService.getHeadlessContent().subscribe((headlesscontent) => {
            if (headlesscontent) {
                this.reload = true;
                this.contentService.removeContentItems(content);
                this.contentService.addHeadlessContentItems(headlesscontent);
                this.changeDetector.detectChanges();
                this.reload = false;
            }
        });
    }

    public onLogout(): void {
        this.accept();
    }

    public toVerzendlijst(): void {
        this.decline();
    }
}
